import { createRouter,createWebHashHistory} from "vue-router";
import xtkReadTrk from "@/components/xtkReadTrk";
import humanHome from "@/components/humanHome";
import faFact from "@/components/page/faFact";
import chBet from "@/components/page/chBet";
import trSr from "@/components/page/trSr";
import hcpMm from "@/components/page/hcpMm";
import standardBrain from "@/components/page/standardBrain";
import standardFibre from "@/components/page/standardFibre";
import languageFunctionMap from "@/components/page/languageFunctionMap";
import statisticsPage from "@/components/page/statistics/statisticsPage.vue";
import ziHome from "@/components/test/ziHome.vue";
import personalElectrical from "@/components/page/personalBrain/personalElectrical.vue";
import personalFibre from "@/components/page/personalBrain/personalFibre.vue";
import visitPage from "@/components/map/visitPage.vue";
import aboutPage from "@/components/page/contact/aboutPage.vue";

/*配置路由*/
const routes = [
    {path: '', redirect : "/home"},
    {path: '/', redirect : "/home"},
    {path:'/home',component: humanHome, meta:{index:1}},
    {path:'/ziHome',component: ziHome, meta:{index:1}},
    {path:'/xtk',component: xtkReadTrk, meta:{index:1}},
    {path:'/faFact',component: faFact, meta:{index:1}},
    {path:'/ch2bet',component: chBet, meta:{index:1}},
    {path:'/trsr',component: trSr, meta:{index:1}},
    {path:'/hcp',component: hcpMm, meta:{index:1}},
    {path:'/standard/surface',component: standardBrain, meta:{index:1}},
    {path:'/standard/fibre',component: standardFibre, meta:{index:1}},
    {path:'/standard/language',component: languageFunctionMap, meta:{index:1}},
    {path:'/statistic',component: statisticsPage, meta:{index:1}},
    {path:'/personal/electrical',component: personalElectrical, meta:{index:1}},
    {path:'/personal/fibre',component: personalFibre, meta:{index:1}},
    {path:'/visit',component: visitPage, meta:{index:1}},
    {path:'/contact',component: aboutPage, meta:{index:1}},
]

/*导出路由模块*/
var router = createRouter({
    history: createWebHashHistory(),
    routes: routes
})

// router.beforeEach((to, form, next) => {
//     const user = store.getters.getUser;
//     if (to.path !== '/noUser' && to.path !== '/error' && to.path !== "/beforeHome") {
//         if (user === undefined) {
//             axios.post("/home/getUserInfo", {}).then(function (res) {
//                 if (res.data.code === util.SUCCESS) {
//                     store.commit("saveUser", res.data.retMap.user);
//                     next();
//                 } else {
//                     util.error(res.data.code);
//                     next({path: "/noUser"});
//                 }
//             }).catch(function (res) {
//                 util.catchErr(res);
//                 next({path: "/noUser"});
//             })
//         }else {
//             next();
//         }
//     } else {
//         next();
//     }
// })

export default router
